// extracted by mini-css-extract-plugin
module.exports = {"condition":"Condition_condition__4CSV6","delete":"Condition_delete__118CZ","or":"Condition_or__1eACd"};